module.exports = __webpack_public_path__ + "img/sup_deposit_crypto5.dc19ae08.jpg";